import { Link } from 'react-router-dom';

export default function About() {
  const orgLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '八戒影视网',
    url: 'https://www.bajieying.com/',
    description: '八戒影视网提供最新高清电影、热播电视剧、热门综艺和动漫免费在线观看，无需付费即可畅享全集完整版。',
    foundingDate: '2023',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'service@bajieying.com',
      availableLanguage: ['Chinese'],
    },
  };

  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '八戒影视网是否需要付费？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '完全不需要！八戒影视网所有影视资源均为免费在线观看，无需付费，无需会员，真正做到零门槛观影体验。',
        },
      },
      {
        '@type': 'Question',
        name: '八戒影视网的视频画质如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '八戒影视网支持1080P超清画质播放，部分热门影片支持4K分辨率。我们采用先进的视频编码技术和全球CDN加速，确保画面清晰流畅。',
        },
      },
      {
        '@type': 'Question',
        name: '在手机上可以使用八戒影视网吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '当然可以！八戒影视网完美适配手机、平板和电脑等各类设备。无论您使用什么设备，都能获得一致的流畅观影体验。',
        },
      },
      {
        '@type': 'Question',
        name: '视频加载慢或卡顿怎么办？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '八戒影视网采用全球CDN加速技术，通常视频可以实现秒速加载。如遇卡顿，建议检查网络连接或尝试切换清晰度选项。',
        },
      },
      {
        '@type': 'Question',
        name: '如何联系八戒影视网客服？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过邮箱 service@bajieying.com 与我们取得联系，我们的客服团队会在24小时内回复您的咨询。',
        },
      },
    ],
  };

  const breadcrumbLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.bajieying.com/' },
      { '@type': 'ListItem', position: 2, name: '关于我们' },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbLd) }}
      />

      {/* Breadcrumb */}
      <div className="w-full px-4 md:px-6 pt-20 pb-0">
        <div className="max-w-5xl mx-auto">
          <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6">
            <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-300">关于我们</span>
          </nav>
        </div>
      </div>

      {/* Hero */}
      <section className="w-full px-4 md:px-6 pb-10">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
            关于八戒影视
          </h1>
          <p className="text-sm text-foreground-500 max-w-2xl">
            八戒影视网致力于为广大影迷提供最优质的高清影视在线观看服务
          </p>
        </div>
      </section>

      {/* Brand introduction */}
      <section className="w-full px-4 md:px-6 py-10 bg-background-100">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-xl font-heading font-bold text-foreground-50 mb-6 flex items-center gap-2">
            <span className="w-1 h-5 bg-primary-500 rounded-full inline-block"></span>
            品牌介绍
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="p-5 rounded-lg bg-background-50 border border-background-200/50">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-400 mb-3">
                <i className="ri-lightbulb-line text-lg"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-50 mb-2">我们的使命</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                八戒影视网成立于2023年，秉承"让每一个人都能免费看好片"的理念，致力于打造一个内容丰富、体验流畅的在线影视平台。我们聚合了海量高清电影、电视剧、综艺和动漫资源，让用户无需付费即可畅享全集完整版。
              </p>
            </div>
            <div className="p-5 rounded-lg bg-background-50 border border-background-200/50">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/10 text-accent-400 mb-3">
                <i className="ri-eye-line text-lg"></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-50 mb-2">我们的愿景</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                我们希望成为华语地区最受欢迎的免费影视平台。通过持续优化播放体验、丰富内容库和提升服务质量，让更多人能够轻松享受高质量的影视内容。未来我们将引入更多独家内容与原创节目，不断提升用户体验。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="w-full px-4 md:px-6 py-10">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
            {[
              { value: '3+', label: '年运营经验' },
              { value: '100K+', label: '影视资源' },
              { value: '50M+', label: '月活用户' },
              { value: '4.8', label: '用户评分' },
            ].map((s, i) => (
              <div key={i} className="text-center p-4 rounded-lg bg-background-100 border border-background-200/50">
                <div className="text-2xl font-heading font-bold text-accent-500 mb-1">{s.value}</div>
                <div className="text-xs text-foreground-500">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Reputation */}
      <section id="reputation" className="w-full px-4 md:px-6 py-10 bg-background-100">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-xl font-heading font-bold text-foreground-50 mb-6 flex items-center gap-2">
            <span className="w-1 h-5 bg-primary-500 rounded-full inline-block"></span>
            用户口碑
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {[
              {
                name: '影迷小李',
                avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20avatar%2C%20friendly%20smile%2C%20casual%20style%2C%20clean%20simple%20background%2C%20warm%20lighting%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
                rating: 5,
                text: '八戒影视真的太棒了！资源超全，更新速度也很快。关键是免费还没有广告打扰，观影体验比很多付费平台都好。已经成为我的追剧首选平台！',
              },
              {
                name: '追剧达人',
                avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20avatar%2C%20warm%20smile%2C%20modern%20casual%20style%2C%20simple%20light%20background%2C%20soft%20lighting%2C%20professional%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish',
                rating: 5,
                text: '用了大半年了，画质清晰、播放流畅，不管是电脑还是手机看都很方便。动漫资源也很全，追番神器！推荐给了身边所有朋友。',
              },
              {
                name: '影视爱好者',
                avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%20avatar%2C%20gentle%20expression%2C%20business%20casual%20style%2C%20clean%20neutral%20background%2C%20warm%20professional%20lighting%2C%20headshot%20photography&width=80&height=80&seq=avatar-03&orientation=squarish',
                rating: 4,
                text: '资源丰富，国产剧和综艺更新特别快。偶尔有些冷门片子不好找，但整体来说已经非常满意了。希望平台越做越好！',
              },
            ].map((review, i) => (
              <div
                key={i}
                className="p-5 rounded-lg bg-background-50 border border-background-200/50"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                    <img src={review.avatar} alt={review.name} className="w-full h-full object-cover" loading="lazy" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-50">{review.name}</p>
                    <div className="flex items-center gap-0.5 mt-0.5">
                      {Array.from({ length: 5 }).map((_, j) => (
                        <i
                          key={j}
                          className={`text-xs ${j < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-600'}`}
                        ></i>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed">{review.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="w-full px-4 md:px-6 py-10">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-xl font-heading font-bold text-foreground-50 mb-6 flex items-center gap-2">
            <span className="w-1 h-5 bg-primary-500 rounded-full inline-block"></span>
            常见问题
          </h2>
          <div className="space-y-3">
            {[
              { q: '八戒影视网是否需要付费？', a: '完全不需要！所有影视资源均为免费在线观看，无需付费，无需会员。' },
              { q: '视频画质如何？', a: '支持1080P超清画质，部分热门影片支持4K分辨率，采用全球CDN加速确保流畅。' },
              { q: '手机可以观看吗？', a: '完美适配手机、平板和电脑等各类设备，随时随地畅享观影。' },
              { q: '视频加载慢怎么办？', a: '采用全球CDN加速技术，通常秒速加载。如遇卡顿建议检查网络或切换清晰度。' },
              { q: '多久更新一次内容？', a: '我们每天24小时不间断更新最新影视资源，热播剧集同步更新，确保您第一时间看到最新内容。' },
            ].map((faq, i) => (
              <div key={i} className="p-4 rounded-lg bg-background-100 border border-background-200/50">
                <h3 className="text-sm font-semibold text-foreground-50 mb-1.5">{faq.q}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="w-full px-4 md:px-6 py-10 bg-background-100">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-xl font-heading font-bold text-foreground-50 mb-6 flex items-center gap-2">
            <span className="w-1 h-5 bg-primary-500 rounded-full inline-block"></span>
            联系我们
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            <div className="p-5 rounded-lg bg-background-50 border border-background-200/50 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-500/10 text-primary-400 mb-3">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-50 mb-1">电子邮箱</h3>
              <p className="text-sm text-foreground-500">service@bajieying.com</p>
            </div>
            <div className="p-5 rounded-lg bg-background-50 border border-background-200/50 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-500/10 text-accent-400 mb-3">
                <i className="ri-wechat-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-50 mb-1">微信公众号</h3>
              <p className="text-sm text-foreground-500">八戒影视网</p>
            </div>
            <div className="p-5 rounded-lg bg-background-50 border border-background-200/50 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-500/10 text-secondary-400 mb-3">
                <i className="ri-time-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-50 mb-1">客服时间</h3>
              <p className="text-sm text-foreground-500">周一至周日 9:00-21:00</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50 mb-3">
            准备好开始你的观影之旅了吗？
          </h2>
          <p className="text-sm text-foreground-500 mb-6">
            海量高清影视资源，全部免费，秒速加载，现在就开始探索吧！
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-fill"></i>
            立即开始观影
          </Link>
        </div>
      </section>
    </>
  );
}